export class ChatClient {
    baseUrl;
    headers;
    constructor(options = {}) {
        this.baseUrl = options.baseUrl ?? '/api';
        this.headers = options.headers ?? {};
    }
    async sendMessage(payload) {
        const response = await fetch(`${this.baseUrl}/chat`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                ...this.headers
            },
            body: JSON.stringify(payload)
        });
        if (!response.ok) {
            throw new Error(`Chat API failed with status ${response.status}`);
        }
        return (await response.json());
    }
}
